import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const NuveiResultMob = () => {
  return <CommonResult />;
};

export default NuveiResultMob;
